import React, { ReactNode } from "react";

import { Text } from "@performyard/py-components";

import { PYLogo } from "../../../../illustrations/PYLogo";

interface PYSurveyContainerProps {
	testId?: string;
	children: ReactNode;
}

export const PYSurveyContainer = ({ children, testId }: PYSurveyContainerProps) => {
	return (
		<div
			data-testid={testId}
			className="flex min-h-[calc(100vh_-_104px)] flex-col items-center justify-center gap-6 bg-neutral-1 pb-10 pt-16"
		>
			<PYLogo />
			{children}
			<div className="flex flex-col items-center justify-center gap-1">
				<Text size="extra-small" weight="regular" color="neutral-7">
					Survey Powered by:
				</Text>
				<PYLogo />
			</div>
		</div>
	);
};
